const amapObj = {
  key: 'a2f69e208e4be10444ff9258fa65306a',
  plugin: [
    'AMap.Autocomplete',
    'AMap.MouseTool',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.OverView',
    'AMap.ToolBar'
  ],
  v: '1.4.8'
};

export const amapLoader = () => new Promise((resolve, reject) => {
  if (window.AMap) {
    resolve(window.AMap);
  } else {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `http://webapi.amap.com/maps?v=${amapObj.v}&plugin=${amapObj.plugin.join(',')}&callback=initAMap&key=${amapObj.key}`;
    script.onerror = reject;
    document.head.appendChild(script);
  }
  window.initAMap = () => {
    resolve(window.AMap);
  };
});

export default {
  amapLoader
};



// WEBPACK FOOTER //
// ./src/common/aMapLoader.js